import { Box, Paper, PaperProps, Typography } from '@material-ui/core';
import React from 'react';

import { Affiliation } from '../../../../services/APIService';
import { formatAddress } from '../../../../services/formatAddress';

interface ContactItemProps {
  contact?: Affiliation;
  type: string;
}

const ContactItem: React.FC<ContactItemProps & Pick<PaperProps, 'style'>> = ({
  contact,
  type,
  ...rootProps
}) => {
  if (!contact) return null;

  return (
    <Paper {...rootProps}>
      <Box p={2} height={1} display="flex" flexDirection="column">
        {!!contact.organization && (
          <Typography variant="subtitle1" gutterBottom>
            {contact.organization}
          </Typography>
        )}
        {!!contact.address &&
          formatAddress(contact.address).map((addressPart) => (
            <Typography key={addressPart} variant="body2">
              {addressPart}
            </Typography>
          ))}
        {!!contact.phone && (
          <Typography variant="body2">{contact.phone}</Typography>
        )}
        <Box mt={2} flex={1} />
        <Typography variant="caption">{type}</Typography>
      </Box>
    </Paper>
  );
};

export default ContactItem;
